<template>
  <div class="cmp-royalty-recoupable-recoupables dt-page">
    <div class="dt-page--top-bar v1">

          <div class="search" style="max-width: 1000px;">
            <DatePicker2
              class="shrink-margin"
              id="start_date"
              :showLabel="false"
              :value="basicFilter.start_date"
              @input="onDateChange"
              lw="70px"
              cw="110px"
              :hoverStyle="1"
              :placeholder="$dft.capHead($t('from'))"
              style="width: 110px"
            />

            <DatePicker2
              class="shrink-margin"
              id="end_date"
              style="margin-left: 8px !important; width: 115px"
              :showLabel="false"
              :value="basicFilter.end_date"
              @input="onDateChange"
              lw="70px"
              cw="110px"
              :hoverStyle="1"
              :placeholder="$dft.capHead($t('to'))"
            />

            <Dropdown
              class="shrink-margin"
              :options="costGroupsTV"
              multiple
              allnone
              :placeholder="$t('cost_group')"
              borderbottom
              :selected="
                costGroupsTV.filter((e) =>
                  basicFilter.cost_groups.includes(e.value)
                )
              "
              @selectedChange="(e) => onDropdownChange('cost_groups', e)"
              :listMinWidth="210"
            >
            </Dropdown>

            <Dropdown
              class="shrink-margin"
              :options="recoupableStatusTV"
              multiple
              allnone
              :placeholder="$t('recoupable_type')"
              borderbottom
              :selected="
                recoupableStatusTV.filter((e) =>
                  basicFilter.status.includes(e.value)
                )
              "
              @selectedChange="(e) => onDropdownChange('status', e)"
              :listMinWidth="205"
              :listHeight="290"
            >
            </Dropdown>

            <Dropdown
              class="shrink-margin"
              :options="periodsTV"
              :placeholder="$t('Period')"
              deselect
              borderbottom
              :selected="
                periodsTV.find((e) => e.value == basicFilter.royalty_period)
              "
              v-on:selectedChange="(e) => onDropdownChange('royalty_period', e)"
              :listMinWidth="100"
              :listHeight="290"
            >
            </Dropdown>

            <button class="dt-button s8" @click="onSearch" style="margin-left: 10px">
              {{ $dft.capHead($t("search")) }}
            </button>
            <DTIconButton
              :classNames="'search--advanced'"
              :text="'Advanced Search'"
              :style="{ minWidth: '148px', marginLeft: '-15px' }"
              icon="add-blue"
              @click="onAdvancedSearchClick"
            />
            <div class="search-config--container">
              <div class="search-config">
                <SearchConBadge
                  v-for="sconKey of filteredAdvancedSearchConfigKeys"
                  :key="sconKey"
                  v-bind="searchConfigKey(sconKey)"
                  @delete="onSearchConDelete"
                />
              </div>
            </div>
          </div>
          <div class="right-container" style="min-width: 260px;">
            <button
              class="dt-button v5 s8"
              @click="autoFetch"
              style="margin-right: 0px"
            >
              {{ $t("run_auto_fetch_all_contracts") }}
            </button>
            <button class="dt-button v5 s8" @click="onAccountAll" style="margin-left: 10px; margin-right: 0px">
              {{ $dft.capHead($t("account_all")) }}
            </button>
            <ThreeDotButton
              style="margin-left: 10px"
              @click="exportCost"
              :options="[
                {
                  text: $t('expense_export_to_excel'),
                  value: 'expense_export_to_excel',
                },
              ]"
            />
          </div>
        </div>



    <div class="dt-page--body"  >
      <template v-if="!accountAllFlag" >  
        <div v-if="filterSelected" class="recoupable-container">
          <div v-if="groupedArray.length > 0" class="recoupable-container"  @scroll="onScroll">
            <div v-for="item in groupedArray" :key="item.title" class="ut-fh">
              <h4
                style="
                  font-weight: bold;
                  padding: 7px;
                  margin-top: 30px;
                  font-size: 14px;
                "
              >
                {{ item.title }}
              </h4>
              <RecoupableTable @changed="onUpdated" :listItem="item" :loadingFlag="loadingFlag" />
            </div>
          </div>
          <div v-else style="height: 100%; align-items: center; display: grid">
            <p style="color: var(--sprt-5); text-align: center">No Items</p>
          </div>
        </div>
        <div v-else style="height: 100%; align-items: center; display: grid">
          <p style="color: var(--sprt-5); text-align: center">
            Please fill in the search options for getting Results
          </p>
        </div>
      </template>
      <template v-else>
        <div style="height: 100%; align-items: center; display: grid">
          <p style="color: var(--sprt-5); text-align: center">
            Please Wait approximately 100 seconds. After that Click On "go" Button to get Accounted Lines.
          </p>
      </div>
      </template>
    </div>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'editRecoupable'"
      :width="'500'"
    >
      <EditRecoupableModal @changed="onUpdated" @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'autoFetch'"
      :width="'500'"
    >
      <AutoFetchModal @cancelled="onCancel" />
    </ModalContainer>

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'costRecoupables'"
      :width="'928'"
    >
      <DBoxCostRecoupables @cancelled="onCostRecoupleblesCancel" />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'costOpenAdvance'"
      :width="'small'"
    >
      <DBoxCostOpenAdvance
        :itemName="'Cost'"
        :config="{}"
        @advance_made="onUpdated"
        @cancelled="onCancel"
      />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'advancedSearch'"
      :width="'400'"
    >
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @searchDropDown="onDropdownSearch"
        @costSearch="onCostSearch"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'accountAll'"
      :width="'400'"
    >
      <AccountAllModal @accountAll="onAccountAllOK" :filter="filter" @cancelled="onCancel" />
    </ModalContainer>
  </div>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { RoyaltyStoreNamespace as storeNS } from "../../store";

import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";

import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";

import ThreeDotButton from "@/dt-plugins/sidewindow/tabMenuButton";

import FileDownload from "js-file-download";
import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import { subscribeSubject } from "../../../../utility";

import { createTV, tv } from "../../../../models/text-value.model";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { recoupableActions } from "../../store/recoupable/actions";
import { recoupableGetters } from "../../store/recoupable/getters";

import { recoupableService } from "../../services/recoupable-service";

import RecoupableTable from "./recoupable-table";
import EditRecoupableModal from "./edit-recoupable-modal";
import AutoFetchModal from "./auto-fetch-modal.vue";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import DBoxCostRecoupables from "../../../../dt-plugins/dbox-costs/dbox-costs-recoupables";
import DBoxCostOpenAdvance from "../../../../dt-plugins/dbox-costs/dbox-costs-open-advance";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { recoupableAdvancedSearchConfig } from "./advance-search.vue";

import AdvancedSearch from "./advance-search.vue";
import AccountAllModal from "./account-all-modal.vue";
import { Subject } from "rxjs";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import axios from 'axios';
import { HttpLib } from "../../../../services/http/http-lib";
import { createHttpGetOptions } from "../../../../services/http/http-client";
export default {
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    RecoupableTable,
    EditRecoupableModal,
    AutoFetchModal,
    DBoxCostRecoupables,
    DBoxCostOpenAdvance,
    AdvancedSearch,
    AccountAllModal,
    ThreeDotButton,
    Sidewindow,
    //AdvanceSearch,
  },
  mounted: async function () {
    console.log("this", this.$route.query);

    this.searchFilter = {
      ...this.searchFilter,
      release_id: this.$route.query.release_id,
    };

    await this[ActionTypes.RecoupableData.FETCH.ALL]();
    this.advancedSearchResponse = this.recoupableData;

    if (this.$route.query.release_id) {
      this.fetchListReset();
    }
    subscribeSubject(this, this.scrollSubject, (searchString) => {
        console.log("STRING SER", searchString);
        console.warn("WWWW", 'searchString, res');

    });
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      royalty_accountsTV: [],
      releasesTV: [],
      costsTV: [],
      cost_groupTV: [],
      selected_royalty_account_id: {},
      selected_invoice_id: {},
      selected_release_id: {},

      defaultConfig: defaultConfig,
      scrollSubject: new Subject(),
      accountAllFlag:false,

      searchType: "none", // release__standard_search, release__weekly_search, release__monthly_search
    };
  },
  mixins: [
    createFetchListMixin(ActionTypes.RecoupableList.FETCH.ALL,30),
    createModalMixin("accountAll"),
    createModalMixin("editRecoupable"),
    createModalMixin("autoFetch"),
    createModalMixin("costOpenAdvance"),
    createModalMixin("costRecoupables"),
    createAdvancedSearchHost(recoupableAdvancedSearchConfig),
    createModalMixin("advancedSearch"),
    // createModalMixin("batchStatement"),

    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, recoupableGetters),

    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },

    filterSelected: function () {
      let val = false;
      const filterObj = { ...this.basicFilter, ...this.searchFilter };

      const keyArray = Object.keys(filterObj);

      keyArray.forEach((e) => {
        const bool1 = filterObj[e] && filterObj[e] != "";
        const bool2 =
          filterObj[e] &&
          Array.isArray(filterObj[e]) &&
          filterObj[e].length > 0;

        if (bool1 || bool2) {
          console.log("filter", filterObj[e] != []);
          val = true;
        }
      });
      return val;
    },

    // labelsTV:function(params) {
    //   return createTV(this.recoupableData?.labels,"label_name","label_id");
    // },

    costGroupsTV: function (params) {
      return createTV(
        this.recoupableData?.cost_groups,
        "cost_group_name",
        "cost_group_id"
      );
    },
    periodsTV: function (params) {
      return createTV(this.recoupableData?.royalty_periods, "label", "value");
    },
    recoupableStatusTV: function () {
      const tvArray = Object.keys(
        this.recoupableData?.recoupable_status_text || {}
      ).map((k) => {
        const tv = {
          text: this.recoupableData?.recoupable_status_text[k],
          value: k,
        };
        //console.log(tv);
        return tv;
      });

      //.filter(e=>e.value!='no_contract'||e.value!='manual_recoupables')
      console.log("TV", tvArray, "TV");
      return tvArray.filter((e) => {
        return e.value != "manual_recoupables" && e.value != "no_contract";
      });
    },

    groupedArray: function () {
      // console.log("DATA WERE",this.recoupableList?.cost_splits);
      const arrObject = this.recoupableList?.cost_splits?.reduce(
        (accum, cur) => {
          // console.log("cur", cur);
          // console.log('accum', accum);
          accum[cur.release_title] = [...(accum[cur.release_title] || []), cur];
          return accum;
        },
        {}
      );

      if (arrObject) {
        console.log(
          "WWWW",
          Object.keys(arrObject).map((e) => {
            return {
              title: `${arrObject[e]["release_date"]}-${arrObject[e]["release_artist"]}-${e}`,
              items: arrObject[e],
            };
          })
        );

        return Object.keys(arrObject).map((e) => {
          return {
            title: `${arrObject[e][0]["release_date"]}-${arrObject[e][0]["identifier"]}-${arrObject[e][0]["release_artist"]}-${e}`,
            items: arrObject[e],
            footerTitle: `Total ${arrObject[e][0]["release_artist"]} / ${e}`,
          };
        });
      }

      return [];
    },
    recoupableAccountId: function () {
      return (
        this.recoupableList?.cost_splits
          ?.filter((e) => e.status == "Account Recoupables")
          .map((k) => {
            return k.cost_split_id;
          }) || []
      );
    },

    advancedSearchData: function () {
      return {
        labelsTV: createTV(
          this.recoupableData?.labels,
          "label_name",
          "label_id"
        ),

        releasesTV: this.releasesTV,
        royaltyAccountsTV: this.royalty_accountsTV,
        costsTV: this.costsTV,
      };
    },
  },
  methods: {
    onUpdated: function (payload) {
      this[ActionTypes.RecoupableList.UPDATE.SINGLE](payload);
      this.onCancel();
    },
    onCostRecoupleblesCancel(){
     this.fetchListReset();
      this.onCancel();
    },
    resetBasicFilter: function () {},

    fetchAdvancedSearchData: async function () {
      // const advancedSearchData = await recoupableService.recoupablesTab();
      // console.log("advancedSearchData",advancedSearchData);
      // this.advancedSearchResponse = this.recoupableData
    },
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        start_date: undefined,
        end_date: undefined,
        cost_groups: [],
        status: [],
        royalty_period: undefined,
        // label_id:undefined,
        // royalty_account_id:undefined,
        // release_id:undefined,
        // invoice_id:undefined
      };
    },
    ...mapActionObject(storeNS, recoupableActions),

    fetchData: function () {
      //  console.log('fetchData');
      this[ActionTypes.StatementList.FETCH.ALL]({
        believe_special: this.$store.getters.account.believe_special,
        start: this.start,
        row_count: this.row_count,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      });
    },

    //scroll

    onStatementNext: function (value) {
      this.scrollSubject.next(value);
    },

    //text chnage and dropdown
    onDateChange: function ({ name, value }) {
      // console.log(name,value)
      this.basicFilter[name] = value;
      // if (this.basicFilter["start_date"]!=undefined && this.basicFilter["end_date"]!=undefined) {
        
      //   this.fetchListReset();
      // }
    },
    onTextFieldChange: function (event, item) {
      // console.log(event,item)
      const payload = {
        kVal: item.royalty_period_id,
        name: event.name,
        value: event.value,
      };
      this[ActionTypes.StatementList.UPDATE.SINGLE](payload);
    },

    onDropdownChange: function (name, value) {
      // <-- Normal Form Handling Methods
      // if (this.basicFilter["start_date"]!=undefined && this.basicFilter["end_date"]!=undefined) {
        if (Array.isArray(value)) {
          // this[name+'TV']=value
          console.log('nv', name, value)
          value = value.map((e) => {
            return e.value;
          });

          this.basicFilter[name] = value;
        } else {
          this.basicFilter[name] = value.value;
        }

        // console.log('nv', name, value)

       // this.fetchListReset();
      // } 
      //   else {
      //   ConfirmationService.createP({
      //     body: this.$t("filter_from_to"),
      //     results: [
      //       createConfirmResult({
      //         value: "ok",
      //         text: "OK",
      //         classes: ["v1 s7"],
      //       }),
      //     ],
      //   });
      // }
    },
    onDropdownSearch: async function ({ e, name, tvInfo, label_id }) {
      const resData = await recoupableService.searchDropdown(e, name, label_id);

      if (tvInfo.tvArray == "releases") {
        console.log(this[tvInfo.tvArray + "TV"], resData);
        this[tvInfo.tvArray + "TV"] = [
          ...(this.advancedSearchData[tvInfo.tvArray + "TV"]?.filter(
            (e) => e.value == this.searchFilter[tvInfo.tvValue]
          ) || []),
          ...resData.data[tvInfo.tvArray]
            .map((x) => {
              return {
                text: `${x["identifier"]} - ${x["release_artist"]} - ${x["release_title"]}`,
                value: x["release_id"],
              };
            })
            .filter((e) => e.value != this.searchFilter[tvInfo.tvValue]),
        ];
        return;
      }

      this[tvInfo.tvArray + "TV"] = [
        ...(this.advancedSearchData[tvInfo.tvArray + "TV"]?.filter(
          (e) => e.value == this.searchFilter[tvInfo.tvValue]
        ) || []),
        ...createTV(
          resData.data[tvInfo.tvArray],
          tvInfo.tvText,
          tvInfo.tvValue
        ).filter((e) => e.value != this.searchFilter[tvInfo.tvValue]),
      ];
    },

    onCostSearch: async function (searchTerm) {
      const resData = await recoupableService.searchCosts(searchTerm);

      // console.log("resData",resData);
      this.costsTV = createTV(
        resData.data.costs,
        "external_ref",
        "invoice_project_id"
      );
    },

    onAutocompleteSelected: function (name, value) {
      this["selected_" + name] = value;
      this.basicFilter[name] = value.value;
      //this.fetchListReset();
    },

    onTextFieldValueChange: function (name, value) {
      this[name] = value;

      // this.selectedProductMedia = {
      //   ...this.selectedProductMedia,
      //   [name]: value,
      // };
    },

    //modal closing

    closeModal: function () {
      closeModalRoute(this);
    },
    onCancel: function () {
      closeModalRoute(this);
    },

    autoFetch: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "auto_fetch",
        },
      });
    },

    exportCost: async function () {
      const resData = await recoupableService.exportCostV2({
        action: "recoupables_xlsx_export",
        ...this.basicFilter,
        ...this.searchFilter
      });

      console.log(resData)

      FileDownload(resData.data, "Recoupables.xlsx");
    },

    onAccountAll: async function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "account_all",
          recoupableAccountId: this.recoupableAccountId,
        },
      });
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Do you want to account all lines with status 'Account Recoupables' ? ",
      // });
      // if (confirmationResult == "OK") {
      //   const dataRes =await recoupableService.accountAllRecoupables(this.balance_date,this.recoupableAccountId);
      //   //  console.log("dataRes" ,dataRes);
      // }
    },

    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },

    onSearch() {
      if (this.basicFilter["start_date"]!=undefined && this.basicFilter["end_date"]!=undefined) {
        this.fetchListReset();
      }else {
        ConfirmationService.createP({
          body: this.$t("filter_from_to"),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
      }
      
    },
    onScroll:function(event){
       this.scrollSubject.next(event.target.scrollTop);

       
    },

    onAccountAllOK:function(value){
      this.accountAllFlag = value
    }
  },
};
</script>

<style lang="scss">
.cmp-royalty-recoupable-recoupables {
  height: calc(100vh - 65px) !important;
  .dt-page--body {
    --offset: 190px;
    .recoupable-container {
      max-height: calc(100vh - 190px);
      overflow-y: auto;
    }
  }

  .search {
    .fc2-datepicker {
      width: 96px;
      max-width: 96px;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
    .dropdown {
      max-width: 137px;
      min-width: 137px;
      margin-left: 10px;
      // &.searchable {
      //   .dropdown--main {
      //     padding-bottom: 6px;
      //     margin-top: 3px;
      //   }
      // }
    }

    .dt-input-box--container {
      min-width: 100px;
      .dt-input-box {
        // border:0px;
        // border-bottom: 1px solid var(--bc-accent);
        // border-radius: 0px;
      }
    }
    .dropdown {
      // max-width: 110px;
      // min-width: 110px;
      // margin-left: 10px;
      &.searchable {
        .dropdown--main {
          padding-bottom: 6px;
          margin-top: 3px;
        }
      }
    }
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 140px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
